if (!Enum) {
    var Enum = {};
}

Enum.VISIT_STATUS = {
    PLANNED: 'PLANNED',
    IN_PROGRESS: 'IN_PROGRESS',
    SUSPENDED: 'SUSPENDED',
    COMPLETED: 'COMPLETED',
    CANCELED: 'CANCELED'
};

Object.freeze(Enum.VISIT_STATUS);